var render, staticRenderFns
import script from "./TournamentStandingsHost.vue?vue&type=script&lang=js&"
export * from "./TournamentStandingsHost.vue?vue&type=script&lang=js&"
import style0 from "./TournamentStandingsHost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5f88f20')) {
      api.createRecord('f5f88f20', component.options)
    } else {
      api.reload('f5f88f20', component.options)
    }
    
  }
}
component.options.__file = "src/components/Tournament/TournamentStandingsHost.vue"
export default component.exports